import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'

import { LoadingSpinner } from '@/components/LoadingSpinner.tsx'
import { NetworkToast } from '@/components/NetworkToast.tsx'
import { useProjectId } from '@/hooks/useProjectId.ts'
import { useSubscription } from '@/hooks/useSubscription.ts'
import { cache } from '@/requests/apollo/cache.ts'
import { useQueryProject } from '@/requests/queries/useQueryProject.ts'
import { useLiveUpdate } from '@/requests/subscriptions/useLiveUpdate.ts'
import { GlobalPubSub } from '@/utils/pubsub.ts'

export const ProjectProviders = () => {
  const [includePast, setIncludePast] = useState(false)
  const { loadingMeta } = useLiveUpdate(includePast)
  const projectId = useProjectId()

  const { load, loading, project } = useQueryProject()

  useSubscription([
    [GlobalPubSub.Signals.TOGGLE_GET_PAST_ITERATIONS, ((value: boolean) => setIncludePast(value)) as Callback],
  ])

  // biome-ignore lint/correctness/useExhaustiveDependencies: This effect should only run when projectId changes
  useEffect(() => {
    cache.evict({ id: 'Story:-1' })
    load()
  }, [projectId])

  return (
    <>
      <NetworkToast />
      {loadingMeta || loading || !project ? (
        <LoadingSpinner className="w-full h-[100vh] absolute top-0 left-0 flex justify-center items-center bg-transparent" />
      ) : (
        <Outlet />
      )}
    </>
  )
}
